import { AnalysisConfig } from "@/components/AnalysisConfig/models/AnalysisConfig";


export class QueueNCAAnalysisArgs {

    // Flattened rules
    constructor(public readonly analysisConfiguration: AnalysisConfig,
        public fileId?: string,
        public name?: string
    ) {
        if (analysisConfiguration == null) throw Error("analysisConfiguration is required");
    }

}